import { ContextTokensProvider } from "./context-tokens-provider";
import { useContextTokens } from "@/shared/security/model/context-tokens/use-context-tokens";

export const ContextTokens = {
  Provider: ContextTokensProvider,
  useContextTokens,
};
